/**
 * `/pos` — the retail counter, full-screen (no workspace shell).
 * @see prototype/pos/register.html (S40) · docs/spec/04-pos.md
 */
import { createFileRoute } from "@tanstack/react-router";
import { PosShell } from "../features/pos/pos-shell.tsx";

export const Route = createFileRoute("/pos")({
  component: PosShell,
});
